import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-props-no-spreading */
import { BackdropLoader, toast, SelectMenu, Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Paper, MenuItem, Typography, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import MultiAmenities from './MultiAmenities';
import { SingleAmenities } from './SingleAmenities';
import { UtilityProviderSetupV2 } from './UtilityProviderSetupV2';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { VACANT_UNIT_USAGE } from 'src/constants/utilities';
import { ALLOCATION_METHOD, VACANT_UNIT_ALLOCATIONS_TO_PAID_BY } from 'src/constants/utilities';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { isValueNumber } from 'src/utils/typeValidators';
import { ProviderSetup } from './ProviderSetup';
import { turnOnApPushFor } from 'src/components/ApPushSwitch';
import glAppfolio from 'src/img/gl-appfolio.svg';
import { PROPERTY_STEPS, APPFOLIO_PROPERTY_STEPS, DEMO_PROPERTY_STEPS } from 'src/constants/property';
export const PropertyUtilitiesSetupPageV2 = observer(_ref => {
  let _ref$handleStep = _ref.handleStep,
    handleStep = _ref$handleStep === void 0 ? () => {} : _ref$handleStep,
    editMode = _ref.editMode,
    mutablePropertyId = _ref.mutablePropertyId,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const CURRENT_STEPS = store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS : PROPERTY_STEPS;
  const propertyId = mutablePropertyId ? mutablePropertyId : notCompletedPropertyId ? notCompletedPropertyId : localStorage.getItem('livable_property_id');
  const view = 'single';
  // const [view, setView] = useState('single');
  // const [buildingSquareData, setBuildingSquareData] = useState(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    glAccounts = _useState4[0],
    setGLAccounts = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    rentGlAccounts = _useState6[0],
    setRentGlAccounts = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    globalGlAccounts = _useState8[0],
    setGlobalGlAccounts = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    payableGlAccounts = _useState0[0],
    setPayableGlAccounts = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    customChargeOnDate = _useState10[0],
    setCustomChargeOnDate = _useState10[1];
  const handleGlAccountSearch = v => {
    const currentArray = [];
    glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setRentGlAccounts(currentArray);
  };
  const handleGlobalGlAccountSearch = v => {
    const currentArray = [];
    glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setGlobalGlAccounts(currentArray);
  };
  const handlePayableGlAccountSearch = v => {
    const currentArray = [];
    glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setPayableGlAccounts(currentArray);
  };
  const getLoading = () => {
    return store.properties.getPropertyAsync.inProgress || store.amenities.getAllCommonAreaAmenitiesRawAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.properties.addPropertyCommonAreaAmenityAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.utilityProviders.getUtilityProvidersAsync.inProgress || store.amenities.getAllAmenitiesRawAsync.inProgress || store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.properties.deletePropertyUtilityProvidersAsync.inProgress || store.utilityProviders.patchPropertyCommonAreaAmenitiesAsync.inProgress || store.propertyUtility.deleteNewPropertyUtilityConfigAsync.inProgress || store.propertyUtility.getPropertyUtilitiesByPropertyAsync.inProgress || store.urjanet.getCompanyCredentialsAsync.inProgress || store.propertyUtility.updateNewPropertyUtilityConfigAsync.inProgress;
  };
  const getUtilityInfo = async ids => {
    const resp = await store.utilityProviders.getUtilityInfoAsync.run({
      utilityIds: ids
    });
    return resp;
  };
  const goToPreviousStep = () => {
    handleStep(store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS.PropertyInformation : localStorage.getItem('livable_demo_mode') !== 'Demo' ? PROPERTY_STEPS.PayoutDetails : DEMO_PROPERTY_STEPS.FeeSetup)();
  };
  const goToNextStep = async () => {
    await store.properties.updatePropertySetupProgressAsync.run({
      propertyId: propertyId,
      propertySetupStep: localStorage.getItem('livable_demo_mode') !== 'Demo' ? Object.keys(CURRENT_STEPS).find(key => CURRENT_STEPS[key] === CURRENT_STEPS.UtilityConfiguration) : Object.keys(DEMO_CURRENT_STEPS).find(key => DEMO_CURRENT_STEPS[key] === DEMO_CURRENT_STEPS.UtilityConfiguration)
    });
    if (localStorage.getItem('livable_demo_mode') !== 'Demo') {
      store.addNewProperty.changeCompletedStep(CURRENT_STEPS.UnitSetup);
      handleStep(CURRENT_STEPS.UnitSetup)();
    } else {
      store.addNewProperty.changeCompletedStep(DEMO_PROPERTY_STEPS.UnitSetup);
      handleStep(DEMO_PROPERTY_STEPS.UnitSetup)();
    }
  };
  const fetchData = async function () {
    let isLoadOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !isLoading && setIsLoading(true);
    store.addNewProperty.utilitiesSetupV2.setRentGlId('');
    store.addNewProperty.utilitiesSetupV2.setGlobalGlId('');
    store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId('');
    store.addNewProperty.utilitiesSetupV2.resetStoreToInitValues();
    setGLAccounts([]);
    setRentGlAccounts([]);
    setGlobalGlAccounts([]);
    setPayableGlAccounts([]);
    if (isLoadOnly) store.credentials.resetUtilitiesGlSettings();

    // No `await` inside this array: `await`-ing the first element suspends before the rest are
    // even called, so the other three could not start until getProperty came back. They ran
    // concurrently with each other once it did; what this recovers is that first serial hop.
    const _await$Promise$all = await Promise.all([store.properties.getPropertyAsync.run({
        propertyId: propertyId
      }), store.properties.getPropertyUtilityProvidersV3Async.run({
        propertyId,
        forceSelectedUpdate: true
      }, [propertyId]).then(async getPropertyUtilityProvidersAsyncResp => {
        var _getPropertyUtilityPr;
        if (getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && getPropertyUtilityProvidersAsyncResp.isSuccessful && getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && (_getPropertyUtilityPr = getPropertyUtilityProvidersAsyncResp.response) !== null && _getPropertyUtilityPr !== void 0 && _getPropertyUtilityPr.length) {
          const UtProvidersIds = getPropertyUtilityProvidersAsyncResp.response.map(utProvider => utProvider.utilityProviderId);
          const getUtilityProvidersListDataAsyncRes = await store.utilityProviders.getUtilityProvidersListDataAsync.run({
            utilityProviderIds: UtProvidersIds
          });
          if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && getUtilityProvidersListDataAsyncRes.isSuccessful) {
            var _getUtilityProvidersL;
            if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && (_getUtilityProvidersL = getUtilityProvidersListDataAsyncRes.response) !== null && _getUtilityProvidersL !== void 0 && _getUtilityProvidersL.length) {
              getUtilityProvidersListDataAsyncRes === null || getUtilityProvidersListDataAsyncRes === void 0 || getUtilityProvidersListDataAsyncRes.response.forEach(utilityProvider => store.addNewProperty.utilitiesSetupV2.addProvider(utilityProvider, true));
              for (const utilityProvider of (_getPropertyUtilityPr2 = getPropertyUtilityProvidersAsyncResp === null || getPropertyUtilityProvidersAsyncResp === void 0 ? void 0 : getPropertyUtilityProvidersAsyncResp.response) !== null && _getPropertyUtilityPr2 !== void 0 ? _getPropertyUtilityPr2 : []) {
                var _getPropertyUtilityPr2;
                const matchingProvider = getUtilityProvidersListDataAsyncRes.response.find(i => i.id === utilityProvider.utilityProviderId);
                const utilitiesToUpdate = !!propertyId && utilityProvider.utilities.map(utility => {
                  const matchUtility = matchingProvider.utilities.find(i => i.id === utility.utilityId);
                  utility.isCustom = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.isCustom;
                  utility.utilityTypeId = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.utilityTypeId;
                  return utility;
                });
                store.addNewProperty.utilitiesSetupV2.setUtilitiesInfoAfterLoad([_objectSpread(_objectSpread({}, matchingProvider), {}, {
                  utilities: utilitiesToUpdate
                })], false);
                if (store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
                  // Sequential on purpose: getVendorsByUtilityProviderIdAsync is one shared
                  // async-model instance, and its run() cancels its own prior in-flight call
                  // (see src/utils/asyncModel/index.ts). Firing these in parallel would
                  // silently drop every provider's vendor data except the last one's.
                  await store.vendors.getVendorsByUtilityProviderIdAsync.run({
                    utilityProviderId: utilityProvider.utilityProviderId
                  });
                }
              }
            }
          }
        }
      }), store.amenities.getAllCommonAreaAmenitiesRawAsync.run(), store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.run({
        propertyId
      })]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 4),
      currentProperty = _await$Promise$all2[0],
      getAllCommonAreaAmenitiesRawAsyncResp = _await$Promise$all2[2],
      propertyCommonAreaAmenitiesResp = _await$Promise$all2[3];
    store.addNewProperty.utilitiesSetupV2.setAvailableCommonAreaAmenities(getAllCommonAreaAmenitiesRawAsyncResp === null || getAllCommonAreaAmenitiesRawAsyncResp === void 0 ? void 0 : getAllCommonAreaAmenitiesRawAsyncResp.response);
    store.addNewProperty.utilitiesSetupV2.setFetchedAmenities(propertyCommonAreaAmenitiesResp === null || propertyCommonAreaAmenitiesResp === void 0 ? void 0 : propertyCommonAreaAmenitiesResp.response);
    if (currentProperty && currentProperty.response && singleElementOfArray(currentProperty.response.buildings).buildingSquare) {
      store.addNewProperty.utilitiesSetupV2.changeSqFootage(singleElementOfArray(currentProperty.response.buildings).buildingSquare.toString());
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _glProperties$respons;
      const glProperties = await store.credentials.getAppfolioPropertiesAsync.run({});
      const currentGlProperty = glProperties === null || glProperties === void 0 || (_glProperties$respons = glProperties.response) === null || _glProperties$respons === void 0 ? void 0 : _glProperties$respons.find(glItem => glItem.propertyLivableId === propertyId);
      setCustomChargeOnDate(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.chargeOnDayOfMonth);
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.rentGlAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setRentGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.rentGlAccountExternalId);
      }
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.glAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setGlobalGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.glAccountExternalId);
      }
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.accountsPayableGlAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.accountsPayableGlAccountExternalId);
      }
      if (isLoadOnly) {
        store.credentials.batchSetUtilitiesGlSettings(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.utilityGlAccounts, store.addNewProperty.utilitiesSetupV2.selectedUtilities);
      }
      await store.credentials.getGLAccountsAsync.run({
        applyToHomeDashboard: false
      }).then(glResp => {
        if (glResp && glResp !== null && glResp !== void 0 && glResp.isSuccessful) {
          setGLAccounts(glResp.response);
          setRentGlAccounts(glResp.response);
          setGlobalGlAccounts(glResp.response);
          setPayableGlAccounts(glResp.response);
        }
      });
    }
    setIsLoading(false);
  };
  const confirmUtilitySetup = async _ref2 => {
    let _ref2$isEdit = _ref2.isEdit,
      isEdit = _ref2$isEdit === void 0 ? false : _ref2$isEdit,
      goNext = _ref2.goNext,
      buildingsRespExt = _ref2.buildingsRespExt,
      _ref2$forceNextStep = _ref2.forceNextStep,
      forceNextStep = _ref2$forceNextStep === void 0 ? true : _ref2$forceNextStep,
      propertySqFootage = _ref2.propertySqFootage;
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      !isLoading && setIsLoading(true);
      const buildingsResp = buildingsRespExt !== undefined ? buildingsRespExt : await store.buildings.getBuildingAsync.run({
        propertyId
      });
      const buildingIds = buildingsResp.isSuccessful && buildingsResp.response.map(item => item.id);
      const utilityProvidersPromises = [];
      for (const utilityProvider of store.addNewProperty.utilitiesSetupV2.utilityProviders) {
        const providerToSave = {
          propertyId: store.addNewProperty.propertyId || propertyId,
          utilityProviderId: utilityProvider.id
        };
        if (!utilityProvider.isFetched) {
          utilityProvidersPromises.push(store.properties.addPropertyUtilityProviderAsync.run(providerToSave));
        }
      }
      await Promise.all(utilityProvidersPromises);
      const utilitiesToCreate = [];
      const utilitiesToSave = [];
      // Utilities chosen for AP Push in the provider setup, by the utility id they are created with (LB-6031). With
      // billing options on there's no choice to collect: a new utility links to a setup, and AP Push is the setup's
      // (LB-6186).
      const apPushChosen = new Set();
      const collectsApPushChoices = !store.account.featureFlagsStore.getIsBillingOptionsEnabled;
      let isAllocationMethodBySquareFootageExist = false;
      for (const selectedUtility of store.addNewProperty.utilitiesSetupV2.selectedUtilities) {
        var _selectedUtility$vaca;
        if (selectedUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || selectedUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) isAllocationMethodBySquareFootageExist = true;
        const vacantUnitUsageLimit = selectedUtility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? store.addNewProperty.vacantUnitUsageLimit.get(selectedUtility.utilityId) / 100 || 0.3 : undefined;
        const utilityToSave = {
          id: selectedUtility.id,
          propertyUtilityId: selectedUtility.id,
          propertyId: store.addNewProperty.propertyId || propertyId,
          utilityProviderId: selectedUtility.utilityProviderId,
          utilityId: selectedUtility.utilityId,
          billFrequencyType: selectedUtility.billFrequencyType,
          allocationMethod: selectedUtility.allocationMethod,
          buildingIds: buildingIds,
          utilityCap: selectedUtility.utilityCap,
          customCommonAreaDeduction: selectedUtility.utilityCAD,
          vacantUnitAllocation: selectedUtility.vacantUnitAllocation,
          vacantUnitUsage: selectedUtility.vacantUnitUsage,
          vacantUnitOccupantsCount: (_selectedUtility$vaca = selectedUtility.vacantUnitOccupantsCount) !== null && _selectedUtility$vaca !== void 0 ? _selectedUtility$vaca : null,
          vacantUnitUsageLimit,
          goodWillDeduction: selectedUtility.goodWillDeduction
        };
        if (selectedUtility.isFetched && selectedUtility.isEnabled) {
          utilitiesToSave.push(utilityToSave);
        } else if (!selectedUtility.isFetched && selectedUtility.isEnabled) {
          if (selectedUtility.isCustom) {
            await store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
              name: selectedUtility.name,
              defaultAllocationMethod: selectedUtility.allocationMethod,
              defaultVacantUnitUsage: selectedUtility.vacantUnitUsage,
              paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[selectedUtility.vacantUnitAllocation],
              cad: selectedUtility.utilityCAD,
              utilityProviderId: selectedUtility.utilityProviderId
            }).then(async attachedUtilityResp => {
              if (attachedUtilityResp.isSuccessful) {
                var _attachedUtilityResp$, _attachedUtilityResp$2, _attachedUtilityResp$3, _attachedUtilityResp$4;
                if (collectsApPushChoices && selectedUtility.isApPushEnabled) apPushChosen.add((_attachedUtilityResp$ = attachedUtilityResp.response) === null || _attachedUtilityResp$ === void 0 ? void 0 : _attachedUtilityResp$.utilityId);
                utilitiesToCreate.push(Object.assign(utilityToSave, {
                  id: (_attachedUtilityResp$2 = attachedUtilityResp.response) === null || _attachedUtilityResp$2 === void 0 ? void 0 : _attachedUtilityResp$2.utilityId,
                  utilityId: attachedUtilityResp === null || attachedUtilityResp === void 0 || (_attachedUtilityResp$3 = attachedUtilityResp.response) === null || _attachedUtilityResp$3 === void 0 ? void 0 : _attachedUtilityResp$3.utilityId,
                  utilityTypeId: attachedUtilityResp === null || attachedUtilityResp === void 0 || (_attachedUtilityResp$4 = attachedUtilityResp.response) === null || _attachedUtilityResp$4 === void 0 ? void 0 : _attachedUtilityResp$4.utilityTypeId
                }));
              }
            });
          } else {
            if (collectsApPushChoices && selectedUtility.isApPushEnabled) apPushChosen.add(utilityToSave.utilityId);
            utilitiesToCreate.push(utilityToSave);
          }
        }
      }
      const finalPromises = [];
      if (utilitiesToCreate && utilitiesToCreate.length) {
        finalPromises.push(store.propertyUtility.addNewPropertyUtilityConfigBatchAsync.run({
          propertyId: propertyId,
          propertyUtilities: utilitiesToCreate
        }));
      }
      if (utilitiesToSave && utilitiesToSave.length) {
        finalPromises.push(store.propertyUtility.updateNewPropertyUtilityConfigBatchAsync.run({
          propertyId: propertyId,
          propertyUtilities: utilitiesToSave
        }));
      }
      if (isAllocationMethodBySquareFootageExist && Number(propertySqFootage) >= 0 && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) >= 0 // &&
      // (!isEdit || goNext === true)
      ) {
        const currentBuildingId = singleElementOfArray(buildingsResp.response).id;
        await store.properties.updatePropertyAsync.run({
          updateStore: true,
          propertyId,
          buildings: [{
            buildingId: currentBuildingId,
            buildingSquare: Number(propertySqFootage) !== Number(store.addNewProperty.utilitiesSetupV2.sqFootage) && isValueNumber(propertySqFootage) ? Number(propertySqFootage) : Number(store.addNewProperty.utilitiesSetupV2.sqFootage)
          }]
        });
      }
      const finalResults = await Promise.all(finalPromises);

      // Chosen for AP Push before they existed: read back for their ids, whichever way the step goes next, and turned on.
      if (apPushChosen.size) {
        await store.properties.getPropertyUtilityProvidersV3Async.run({
          propertyId,
          forceSelectedUpdate: true
        }, [propertyId]);
        if ((await turnOnApPushFor(apPushChosen, store.addNewProperty.utilitiesSetupV2.selectedUtilities)) > 0) {
          toast('warning', {
            title: "AP Push couldn't be turned on for every utility",
            body: ["Turn it on in the utility's details."]
          });
        }
      }
      for (const selectedAmenity of store.addNewProperty.utilitiesSetupV2.selectedAmenities) {
        const amenityToSave = {
          propertyId: store.addNewProperty.propertyId || propertyId,
          commonAreaAmenityId: selectedAmenity.id,
          commonAreaAmenityOptionId: selectedAmenity.amenitySelectedOption,
          buildingIds: buildingIds
        };
        if (!selectedAmenity.isFetched) {
          await store.properties.addPropertyCommonAreaAmenityAsync.run(amenityToSave);
        }
      }
      setIsLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      if ((!isEdit || goNext === true) && forceNextStep) {
        await goToNextStep();
      } else {
        if (editMode && mutablePropertyId && !finalResults.includes(undefined)) {
          toast('success', {
            body: ['Successfully saved']
          });
        }
        await fetchData().then(async () => {
          if (store.credentials.utilitiesGlSettings.length > 0) {
            const cUtilityArray = store.credentials.buildUtilityGlAccountsPatchValue({
              selectedUtilities: store.addNewProperty.utilitiesSetupV2.selectedUtilities,
              defaultGlAccountExternalId: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
              includePayable: store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled
            });
            await store.credentials.patchAppfolioPropertiesAsync.run({
              properties: [{
                propertyLivableId: propertyId,
                utilityGlAccounts: {
                  value: cUtilityArray
                }
              }]
            });
          }
          if (store.addNewProperty.utilitiesSetupV2.utilityIds.length) return getUtilityInfo(store.addNewProperty.utilitiesSetupV2.utilityIds);
        }).finally(() => setIsLoading(false));
      }
    } catch (error) {
      console.error('STORE ERROR > ', error);
      setIsLoading(false);
    }
  };
  const saveUtilityProviderSetup = async _ref3 => {
    let goNext = _ref3.goNext,
      forceNextStep = _ref3.forceNextStep,
      propertySqFootage = _ref3.propertySqFootage;
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      !isLoading && setIsLoading(true);
      const buildingsResp = await store.buildings.getBuildingAsync.run({
        propertyId
      });
      let clearUtilitiesToDelete = false;
      const utilityToDeleteResPromises = [];
      // delete billing configs to save
      for (const _ref4 of Object.entries(store.addNewProperty.utilitiesSetupV2.selectedUtilitiesToDelete)) {
        var _ref5 = _slicedToArray(_ref4, 2);
        const utilityToDelete = _ref5[1];
        utilityToDeleteResPromises.push(store.propertyUtility.deleteNewPropertyUtilityConfigAsync.run({
          propertyId: propertyId,
          utilityId: utilityToDelete.id,
          propertyUtilityId: utilityToDelete.id
        })
        // eslint-disable-next-line @typescript-eslint/no-loop-func
        .then(utilityToDeleteRes => {
          clearUtilitiesToDelete = utilityToDeleteRes && utilityToDeleteRes.isSuccessful;
        }));
      }
      await Promise.all(utilityToDeleteResPromises);
      if (clearUtilitiesToDelete) {
        store.addNewProperty.utilitiesSetupV2.wipeUtilityToDelete();
      }
      let clearPropertyUtilityProviderDelete = false;
      // const propertyUtilityProviderDeleteResPromises = [];
      // providers to save delete fetched providers
      for (const _ref6 of Object.entries(store.addNewProperty.utilitiesSetupV2.utilityProvidersToDelete)) {
        var _ref7 = _slicedToArray(_ref6, 2);
        const utilityProviderToDelete = _ref7[1];
        // propertyUtilityProviderDeleteResPromises.push(
        await store.properties.deletePropertyUtilityProvidersAsync.run({
          propertyId,
          utilityProviderId: utilityProviderToDelete.id
        })
        // eslint-disable-next-line @typescript-eslint/no-loop-func
        .then(propertyUtilityProviderDeleteRes => {
          clearPropertyUtilityProviderDelete = propertyUtilityProviderDeleteRes && propertyUtilityProviderDeleteRes.isSuccessful;
        });
        // );
      }
      // await Promise.all(propertyUtilityProviderDeleteResPromises);

      if (clearPropertyUtilityProviderDelete) {
        store.addNewProperty.utilitiesSetupV2.wipeUtilityProviderToDelete();
      }

      // bulk update amenities
      const amenitiesToUpdate = store.addNewProperty.utilitiesSetupV2.selectedAmenities.length > 0 ? store.addNewProperty.utilitiesSetupV2.selectedAmenities.filter(amenity => amenity.isFetched).map(i => {
        return {
          commonAreaAmenityId: i.commonAreaAmenityId,
          commonAreaAmenityOptionId: i.amenitySelectedOption
        };
      }) : [];
      const amenitiesToDelete = store.addNewProperty.utilitiesSetupV2.selectedAmenitiesToDelete.map(i => i.commonAreaAmenityId);
      if (amenitiesToUpdate.length || amenitiesToDelete.length) {
        let clearAmenitiesToDelete = false;
        const amenityPatchRes = await store.utilityProviders.patchPropertyCommonAreaAmenitiesAsync.run({
          propertyId,
          toCreate: [],
          toUpdate: amenitiesToUpdate,
          toDelete: amenitiesToDelete
        });
        clearAmenitiesToDelete = amenityPatchRes && amenityPatchRes.isSuccessful;
        if (clearAmenitiesToDelete) {
          store.addNewProperty.utilitiesSetupV2.wipeCADToDelete();
        }
      }
      if (store.company.companyFeatureStore.isAppfolio) {
        const currentRentGl = {
          rentGlAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId : null
          }
        };
        const currentglobalGl = {
          glAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId : null
          }
        };
        const currentPayableGl = store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled ? {
          accountsPayableGlAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.accountsPayableGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.accountsPayableGlAccountExternalId : null
          }
        } : {};
        const chargeOnDayOfMonth = {
          value: customChargeOnDate
        };
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [_objectSpread(_objectSpread(_objectSpread(_objectSpread({
            propertyLivableId: propertyId
          }, currentRentGl), currentglobalGl), currentPayableGl), {}, {
            chargeOnDayOfMonth
          })]
        });
      }
      if (store.credentials.utilitiesGlSettings.length > 0) {
        const cUtilityArray = store.credentials.buildUtilityGlAccountsPatchValue({
          selectedUtilities: store.addNewProperty.utilitiesSetupV2.selectedUtilities,
          defaultGlAccountExternalId: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
          includePayable: store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled
        });
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [{
            propertyLivableId: propertyId,
            utilityGlAccounts: {
              value: cUtilityArray
            }
          }]
        });
      }
      if (store.vendors.tempData.utilityProviderLivableId && store.vendors.tempData.vendorExternalId && store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
        await store.vendors.associateVendorsAsync.run({
          utilityProviderLivableId: store.vendors.tempData.utilityProviderLivableId,
          vendorExternalId: store.vendors.tempData.vendorExternalId
        });
        store.vendors.changeTempDataVendor(null);
        store.vendors.changeTempDataProperty(null);
      }
      setIsLoading(false);
      // last step
      await confirmUtilitySetup({
        isEdit: !notCompletedPropertyId,
        goNext,
        buildingsRespExt: buildingsResp,
        forceNextStep,
        propertySqFootage
      });
    } catch (e) {
      console.log('error', e);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData(true).then(() => {
      if (store.addNewProperty.utilitiesSetupV2.utilityIds.length) return getUtilityInfo(store.addNewProperty.utilitiesSetupV2.utilityIds);
    }).finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      goToPreviousStep();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      saveUtilityProviderSetup({
        goNext: true
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.title
  }, t('General ledger(GL) accounts'), /*#__PURE__*/React.createElement("img", {
    src: glAppfolio,
    width: "24",
    height: "24",
    alt: "GL logo",
    title: "GL logo"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select which of the AppFolio general ledger accounts is in use for rent.  It is necessary to identify the rent charge in your AppFolio ledger when preparing statements.')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, t('Rent GL account')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select which of the AppFolio general ledger accounts is in use for rent.  It is necessary to identify the rent charge in your AppFolio ledger when preparing statements.')), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccount
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.glAccountData
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "gl-selector",
    enableSearch: true,
    labelId: "gl-selector-label",
    label: "Select rent GL account",
    disabled: glAccounts.length === 0,
    onSearch: handleGlAccountSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      store.addNewProperty.utilitiesSetupV2.setRentGlId(e.target.value);
      setRentGlAccounts(glAccounts);
    },
    value: store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId,
    renderValue: selected => {
      var _rentGlAccounts$find;
      if (selected.length === 0) {
        return '';
      }
      return (_rentGlAccounts$find = rentGlAccounts.find(item => item.externalId === selected)) === null || _rentGlAccounts$find === void 0 ? void 0 : _rentGlAccounts$find.name;
    }
  }, rentGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number))))), store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId && /*#__PURE__*/React.createElement("div", {
    className: classes.glAccountRemove
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      store.addNewProperty.utilitiesSetupV2.setRentGlId('');
    },
    'custom-attribute': '147-property-utilities-setup-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, t('Default Resident Charges GL Account (Income)')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select the default GL account for all utilities. You specify GL codes for specific utilities when adding a billing template.')), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccount
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "gl-selector",
    enableSearch: true,
    labelId: "gl-selector-label",
    label: "Select default resident charges GL account",
    disabled: glAccounts.length === 0,
    onSearch: handleGlobalGlAccountSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      store.addNewProperty.utilitiesSetupV2.setGlobalGlId(e.target.value);
      setGlobalGlAccounts(glAccounts);
    },
    value: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
    renderValue: selected => {
      var _globalGlAccounts$fin;
      if (selected.length === 0) {
        return '';
      }
      return (_globalGlAccounts$fin = globalGlAccounts.find(item => item.externalId === selected)) === null || _globalGlAccounts$fin === void 0 ? void 0 : _globalGlAccounts$fin.name;
    }
  }, globalGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number))))), store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, t('Default Accounts Payable GL Account (Expense)')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select the GL account used for accounts payable.')), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccount
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "payable-gl-selector",
    enableSearch: true,
    labelId: "payable-gl-selector-label",
    label: "Select default accounts payable GL account",
    disabled: glAccounts.length === 0,
    onSearch: handlePayableGlAccountSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId(e.target.value);
      setPayableGlAccounts(glAccounts);
    },
    value: store.addNewProperty.utilitiesSetupV2.accountsPayableGlAccountExternalId,
    renderValue: selected => {
      var _payableGlAccounts$fi;
      if (selected.length === 0) {
        return '';
      }
      return (_payableGlAccounts$fi = payableGlAccounts.find(item => item.externalId === selected)) === null || _payableGlAccounts$fi === void 0 ? void 0 : _payableGlAccounts$fi.name;
    }
  }, payableGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.credentials.getAppfolioPropertiesAsync.inProgress
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, t('Custom charge on date')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('Select the day each month you’d like us to post transactions.'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t('Set the date to post the charge or credit — if you leave it blank, we’ll use today’s date.'),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      marginTop: '10px'
    }
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "customChargeOnDate-selector",
    value: customChargeOnDate
    // label={t('Day of the month to charge')}
    ,
    onChange: event => setCustomChargeOnDate(event.target.value),
    'custom-attribute': '855-property-utilities-setup-page'
  }, Array.from({
    length: 28
  }, (_, i) => {
    const value = i + 1;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value
    }, value);
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.glAccountRemove
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      setCustomChargeOnDate(null);
    },
    'custom-attribute': '855-property-utilities-setup-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))))), store.account.featureFlagsStore.getIsBillAutomationEnabled && store.account.featureFlagsStore.getIsBillingTemplatesEnabled && /*#__PURE__*/React.createElement(ProviderSetup, {
    propertyId: propertyId
  }), /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, view === 'single' && /*#__PURE__*/React.createElement(SingleAmenities, {
    amenities: store.addNewProperty.utilitiesSetupV2.selectedAmenities,
    isEdit: editMode || notCompletedPropertyId,
    isLoading: isLoading || getLoading()
  })), (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) && /*#__PURE__*/React.createElement(UtilityProviderSetupV2, {
    isEdit: editMode,
    id: 'UtilityProviderSetupV2_Id',
    key: 'UtilityProviderSetupV2_Key',
    propertyId: propertyId,
    onSave: saveUtilityProviderSetup,
    isParentLoading: isLoading || getLoading()
  }), !editMode && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goToPreviousStep,
    disabled: isLoading || getLoading(),
    variant: "text",
    'custom-attribute': '148-property-utilities-setup-page'
  }, t('general.back'), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, ': ', localStorage.getItem('livable_demo_mode') !== 'Demo' ? t('subscriptions.payment_information') : t('add_new_property_flow.fee_structure'))), /*#__PURE__*/React.createElement(Button, {
    onClick: () => saveUtilityProviderSetup({
      goNext: true
    }),
    disabled: isLoading || getLoading() || store.addNewProperty.utilitiesSetupV2.setupWritesInFlight > 0 || store.company.companyFeatureStore.isAppfolio && !store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId || store.addNewProperty.utilitiesSetupV2.selectedUtilities.filter(i => i.isEnabled && (ALLOCATION_METHOD.BySquareFootage === i.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === i.allocationMethod) && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0).length !== 0,
    variant: "priority",
    'custom-attribute': '149-property-utilities-setup-page'
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('buttons.confirm'), ". ", t('general.next')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('general.next'), ": ", t('add_new_property_flow.unit_setup')))), editMode && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: saveUtilityProviderSetup,
    disabled: isLoading || getLoading() || store.addNewProperty.utilitiesSetupV2.setupWritesInFlight > 0 || store.addNewProperty.utilitiesSetupV2.selectedUtilities.filter(i => i.isEnabled && (ALLOCATION_METHOD.BySquareFootage === i.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === i.allocationMethod) && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0).length !== 0,
    variant: "priority",
    'custom-attribute': '150-property-utilities-setup-page'
  }, t('buttons.save'))));
});
PropertyUtilitiesSetupPageV2.propTypes = {
  handleStep: PropTypes.func
};